import { useMemo } from 'react';

import { toUserName } from 'features/other/organizationStructureMUI/utils';
import { joinString } from 'utils/string';

// for region + agency
export const useGenerateAreaOptions = (options) => {
	return useMemo(
		() =>
			options.map((option) => ({
				name: joinString(' - ', [option?.id, option?.name]),
				code: option.id,
			})),
		[options],
	);
};

// for manager, seller, ppz
export const useGeneratePersonOptions = (persons) => {
	return useMemo(
		() =>
			persons.map((person) => ({
				name: toUserName(person).fullName,
				code: person.login,
			})),
		[persons],
	);
};
